import { withI18n } from 'react-i18next';
import PaymentMethodChange from './PaymentMethodChange';

export const pureComponent = PaymentMethodChange;
export default withI18n()(PaymentMethodChange);
